import React, { useState } from 'react';
import API from '../services/api';

const WorkRefusalForm = ({ formData = {}, onInputChange = () => {}, onFormSubmit, incidentId } ) => {
  // Local state for this form's specific fields
  const [refusalData, setrefusalData] = useState({
    issueDescription: '',
    photos: []
  });

  const [loading, setLoading] = useState(false);

  // Handle local form changes
  const handleLocalChange = (e) => {
    const { name, value, type, files } = e.target;
    
    if (type === 'file') {
      setrefusalData({
        ...refusalData,
        [name]: Array.from(files)
      });
    } else {
      setrefusalData({
        ...refusalData,
        [name]: value 
      });
    }
  };

  // Upload photos to the server
  const uploadPhotos = async (photos) => {
    const uploadedFiles = [];
    for (const file of photos) {
      const formData = new FormData();
      formData.append('photo', file);

      const res = await API.post(
        `/api/incidents/${incidentId}/work-refusal-photo`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      uploadedFiles.push(res.data);
    }
    return uploadedFiles;
  };

  // Submit the form data to parent
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    let photoUrls = [];
    if (refusalData.photos.length > 0) {
      const uploadedFiles = await uploadPhotos(refusalData.photos);
      photoUrls = uploadedFiles.map(f => f.url); // or .id, depending on your backend
    }

  await API.post(`/api/incidents/${incidentId}/forms`, {
      formType: 'Work Refusal',
      formData: {
        issueDescription: refusalData.issueDescription,
        photoUrls, // <-- Only URLs/IDs, not file objects!
        // ...other fields
      }
    });

    onFormSubmit(refusalData, incidentId);
    setLoading(false);
  };
 
  return (
    <form onSubmit={handleSubmit}>
      <h3 className="text-lg font-medium mb-4">Work Refusal Details</h3>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Description of the Refusal</label>
        <textarea
          name="issueDescription"
          value={refusalData.issueDescription}
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2 h-32"
          required
          placeholder="Provide a detailed description of the refusal and what made you feel
          the work was unsafe. Describe the details you took to make it not a hazard for others."
        ></textarea>
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 mb-1">Attach Photos</label>
        <input
          type="file"
          name="photos"
          onChange={handleLocalChange}
          className="w-full border rounded-md px-3 py-2"
          multiple
          accept="image/*"
        />
        {refusalData.photos.length > 0 && (
          <div className="mt-2">
            <p className="text-sm text-gray-600">{refusalData.photos.length} file(s) selected</p>
            <ul className="text-xs text-gray-500 mt-1">
              {refusalData.photos.map((photo, index) => (
                <li key={index}>{photo.name}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      
      <div className="flex justify-end">
        <button 
          type="submit" 
          disabled={loading}
          className={loading ? 'submit-button disabled' : 'submit-button'}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </form>
  );
};

export default WorkRefusalForm;